// extracted by mini-css-extract-plugin
export var black = "_30-6";
export var brand = "_30-1";
export var ddefault = "_30-0";
export var error = "_30-3";
export var gray = "_30-2";
export var highContrast = "_30-8";
export var outline = "_30-7";
export var success = "_30-5";
export var warning = "_30-4";